import type { ItemLinkValue } from '@/common/api/types/items';
import { OverflowTooltip } from '@/common/components/ui/OverflowTooltip';

export const LinkCell = ({ value }: { value?: ItemLinkValue }) =>
  value && (
    <OverflowTooltip
      tooltipContent={value.description || value.LINK}
      className="text-text-link hover:text-text-link-hovered underline"
    >
      <a href={value.LINK} target="_blank" rel="noopener noreferrer">
        {value.description || value.LINK}
      </a>
    </OverflowTooltip>
  );
